export const WELCOME_COMMON = {
    title: [
        '欢迎使用知行助手'
    ],
    introduction: [
        '您好，我是知行助手'
    ],
    features: [
        '我能用对话聊天的方式，帮助人们获取行业知识',
        '我拥有会话记忆能力，让沟通过程更流畅',
        '我能够将我对问题的思考和推理过程进行展示，做到公开、透明'
    ],
    tips: [
        { model: 'commonMode', prompt: '佳都科技在城市交通行业的竞争优势是什么？' },
        { model: 'intel-customer', prompt: '从机场南站去大学城北站怎么换乘？要多少钱？' },
        { model: 'opera-assistant', prompt: '地铁屏蔽门不能关闭，如何处理？' }
    ]
};

export const WELCOME_KNOWLEDGE = {
    title: [
        '欢迎使用知行助手'
    ],
    introduction: [
        '您好，我是知行助手'
    ],
    tag: [
        '知识库对话'
    ],
    features: [
        '可在预设中选择一个话题，进行对话，我将对其进行分析',
        '可以自定义创建个人知识库'
    ]
};

export const WELCOME_MODELS = {
    title: [
        '欢迎使用知行助手'
    ],
    introduction: [
        '助手中心'
    ],
    features: [
        '场景任务一键搞定，打造高效的生产力工具'
    ]
};
